import React, { useState, useEffect } from 'react';
import api from '../services/api'; // Importa o serviço de API configurado

const EnemTriSimulatorBar = ({ user }) => {
  const [correctAnswers, setCorrectAnswers] = useState({
    linguagens: 0,
    humanas: 0,
    natureza: 0,
    matematica: 0
  });

  const [weights, setWeights] = useState({
    linguagens: 1,
    humanas: 1,
    natureza: 1,
    matematica: 1,
    redacao: 1
  });

  const [simulatedScores, setSimulatedScores] = useState({
    linguagens: 0,
    humanas: 0,
    natureza: 0,
    matematica: 0,
    redacao: 800
  });

  // ENEM scoring table based on the provided data
  const enemScoringTable = {
    linguagens: [
      null, // 0 acertos (not used)
      294.8, // 1 acerto
      303.2, // 2 acertos
      313.2, // 3 acertos
      321.4, // 4 acertos
      332.5, // 5 acertos
      344.3, // 6 acertos
      356.9, // 7 acertos
      369.9, // 8 acertos
      383.8, // 9 acertos
      398.0, // 10 acertos
      411.9, // 11 acertos
      426.0, // 12 acertos
      439.1, // 13 acertos
      452.0, // 14 acertos
      463.7, // 15 acertos
      475.2, // 16 acertos
      485.8, // 17 acertos
      495.8, // 18 acertos
      505.2, // 19 acertos
      514.1, // 20 acertos
      522.8, // 21 acertos
      531.0, // 22 acertos
      539.1, // 23 acertos
      547.1, // 24 acertos
      555.0, // 25 acertos
      562.9, // 26 acertos
      570.8, // 27 acertos
      578.9, // 28 acertos
      587.0, // 29 acertos
      595.3, // 30 acertos
      603.8, // 31 acertos
      612.7, // 32 acertos
      622.0, // 33 acertos
      631.6, // 34 acertos
      641.9, // 35 acertos
      652.8, // 36 acertos
      664.3, // 37 acertos
      676.8, // 38 acertos
      690.2, // 39 acertos
      704.8, // 40 acertos
      721.0, // 41 acertos
      738.5, // 42 acertos
      758.9, // 43 acertos
      788.3, // 44 acertos
      820.8  // 45 acertos
    ],
    humanas: [
      null, // 0 acertos (not used)
      301.0, // 1 acerto
      308.6, // 2 acertos
      316.3, // 3 acertos
      324.8, // 4 acertos
      333.3, // 5 acertos
      342.6, // 6 acertos
      353.2, // 7 acertos
      365.0, // 8 acertos
      377.6, // 9 acertos
      391.4, // 10 acertos
      405.6, // 11 acertos
      420.6, // 12 acertos
      435.5, // 13 acertos
      449.8, // 14 acertos
      463.7, // 15 acertos
      476.7, // 16 acertos
      488.8, // 17 acertos
      500.0, // 18 acertos
      510.3, // 19 acertos
      520.0, // 20 acertos
      529.2, // 21 acertos
      537.7, // 22 acertos
      546.0, // 23 acertos
      553.9, // 24 acertos
      561.6, // 25 acertos
      569.3, // 26 acertos
      576.8, // 27 acertos
      584.2, // 28 acertos
      591.7, // 29 acertos
      599.5, // 30 acertos
      607.4, // 31 acertos
      615.3, // 32 acertos
      624.0, // 33 acertos
      632.9, // 34 acertos
      642.4, // 35 acertos
      652.8, // 36 acertos
      663.9, // 37 acertos
      676.0, // 38 acertos
      689.2, // 39 acertos
      704.1, // 40 acertos
      720.9, // 41 acertos
      740.2, // 42 acertos
      762.8, // 43 acertos
      791.4, // 44 acertos
      823.0  // 45 acertos
    ],
    natureza: [
      null, // 0 acertos (not used)
      338.3, // 1 acerto
      351.3, // 2 acertos
      364.0, // 3 acertos
      376.4, // 4 acertos
      388.8, // 5 acertos
      401.0, // 6 acertos
      414.3, // 7 acertos
      427.9, // 8 acertos
      442.8, // 9 acertos
      458.5, // 10 acertos
      474.9, // 11 acertos
      491.9, // 12 acertos
      509.4, // 13 acertos
      526.9, // 14 acertos
      544.1, // 15 acertos
      560.7, // 16 acertos
      576.2, // 17 acertos
      590.3, // 18 acertos
      603.0, // 19 acertos
      614.3, // 20 acertos
      624.4, // 21 acertos
      633.5, // 22 acertos
      641.9, // 23 acertos
      649.8, // 24 acertos
      657.5, // 25 acertos
      664.7, // 26 acertos
      671.8, // 27 acertos
      679.1, // 28 acertos
      686.0, // 29 acertos
      693.2, // 30 acertos
      700.3, // 31 acertos
      707.6, // 32 acertos
      715.3, // 33 acertos
      722.9, // 34 acertos
      731.1, // 35 acertos
      739.3, // 36 acertos
      748.0, // 37 acertos
      757.4, // 38 acertos
      767.3, // 39 acertos
      778.0, // 40 acertos
      790.8, // 41 acertos
      805.4, // 42 acertos
      823.9, // 43 acertos
      845.2, // 44 acertos
      868.4  // 45 acertos
    ],
    matematica: [
      null, // 0 acertos (not used)
      336.3, // 1 acerto
      343.3, // 2 acertos
      350.7, // 3 acertos
      359.7, // 4 acertos
      370.3, // 5 acertos
      382.0, // 6 acertos
      395.5, // 7 acertos
      410.6, // 8 acertos
      428.1, // 9 acertos
      447.8, // 10 acertos
      469.3, // 11 acertos
      492.8, // 12 acertos
      517.2, // 13 acertos
      541.9, // 14 acertos
      565.5, // 15 acertos
      588.0, // 16 acertos
      608.0, // 17 acertos
      626.1, // 18 acertos
      642.6, // 19 acertos
      656.9, // 20 acertos
      670.1, // 21 acertos
      682.1, // 22 acertos
      693.7, // 23 acertos
      704.5, // 24 acertos
      714.8, // 25 acertos
      724.9, // 26 acertos
      734.7, // 27 acertos
      744.7, // 28 acertos
      754.6, // 29 acertos
      764.7, // 30 acertos
      775.2, // 31 acertos
      785.6, // 32 acertos
      796.8, // 33 acertos
      808.0, // 34 acertos
      819.7, // 35 acertos
      831.7, // 36 acertos
      845.0, // 37 acertos
      858.8, // 38 acertos
      873.7, // 39 acertos
      890.2, // 40 acertos
      907.9, // 41 acertos
      927.6, // 42 acertos
      945.7, // 43 acertos
      958.6, // 44 acertos
      961.9  // 45 acertos
    ]
  };

  // Function to get ENEM score based on correct answers using the official table
  const getEnemScore = (subject, correctCount) => {
    if (correctCount <= 0) {
      return null; // Return null for 0 acertos as per requirement
    }

    if (correctCount >= 1 && correctCount <= 45) {
      return enemScoringTable[subject][correctCount];
    }

    return null; // Out of range
  };

  const handleInputChange = (subject, value) => {
    // Handle empty value case - allow clearing but treat as 0 internally
    if (value === '' || value === null || value === undefined) {
      setCorrectAnswers(prev => ({
        ...prev,
        [subject]: 0
      }));
      setSimulatedScores(prev => ({
        ...prev,
        [subject]: 0
      }));
      return;
    }

    // Parse the value and ensure it's between 1 and 45 (minimum 1 as per requirements)
    const parsedValue = parseInt(value);
    if (isNaN(parsedValue) || parsedValue < 1) {
      // If the value is not a valid number or less than 1, don't update
      return;
    }

    const numValue = Math.min(45, parsedValue); // Maximum 45, minimum 1 by requirement
    setCorrectAnswers(prev => ({
      ...prev,
      [subject]: numValue
    }));

    // Update the corresponding score immediately
    if (numValue >= 1 && numValue <= 45) {
      const score = getEnemScore(subject, numValue);
      if (score !== null) {
        setSimulatedScores(prev => ({
          ...prev,
          [subject]: Math.round(score)
        }));
      }
    }
  };

  const handleWeightChange = (subject, value) => {
    // Allow empty values during user input
    if (value === '' || value === null || value === undefined) {
      setWeights(prev => ({
        ...prev,
        [subject]: ''
      }));
      return;
    }

    const numValue = Math.max(0.1, Math.min(10, parseFloat(value) || 1)); // Min 0.1, Max 10
    setWeights(prev => ({
      ...prev,
      [subject]: numValue
    }));
  };

  const simulateScores = () => {
    const newScores = {
      linguagens: correctAnswers.linguagens >= 1 ? Math.round(getEnemScore('linguagens', correctAnswers.linguagens)) : 0,
      humanas: correctAnswers.humanas >= 1 ? Math.round(getEnemScore('humanas', correctAnswers.humanas)) : 0,
      natureza: correctAnswers.natureza >= 1 ? Math.round(getEnemScore('natureza', correctAnswers.natureza)) : 0,
      matematica: correctAnswers.matematica >= 1 ? Math.round(getEnemScore('matematica', correctAnswers.matematica)) : 0,
      redacao: simulatedScores.redacao // Keep the user-inputted redação score
    };
    setSimulatedScores(newScores);
  };

  const resetForm = () => {
    setCorrectAnswers({
      linguagens: 0,
      humanas: 0,
      natureza: 0,
      matematica: 0
    });
    setWeights({
      linguagens: 1,
      humanas: 1,
      natureza: 1,
      matematica: 1,
      redacao: 1
    });
    setSimulatedScores({
      linguagens: 0,
      humanas: 0,
      natureza: 0,
      matematica: 0,
      redacao: 800
    });
  };

  // State to control showing results
  const [showResults, setShowResults] = useState(false);
  const [resultsAnimation, setResultsAnimation] = useState(false);
  const [resultsVisible, setResultsVisible] = useState(false);
  const [showUpgradeMessage, setShowUpgradeMessage] = useState(false);
  const [calculatedAverages, setCalculatedAverages] = useState({ simpleAverage: 0, weightedAverage: 0 });
  const [triAccessStatus, setTriAccessStatus] = useState(null); // Estado para armazenar o status real do acesso TRI
  const [checkingAccess, setCheckingAccess] = useState(false); // Estado para indicar se estamos verificando o acesso

  // Check if user has access to the ENEM TRI simulator - only through the TRI page in admin panel
  const hasAccessToEnemSimulator = triAccessStatus !== null ?
    triAccessStatus.hasAccess :
    (user && (user.hasTriAccess === true && (!user.triAccessExpiry || new Date(user.triAccessExpiry) > new Date())));

  // Function to check TRI access status in real-time
  const checkTriAccessStatus = async () => {
    if (!user) return;

    setCheckingAccess(true);
    try {
      // Obter token do objeto user ou do localStorage
      let token = null;
      if (user && user.token) {
        token = user.token;
      } else {
        // Tentar obter do localStorage
        const userInfo = localStorage.getItem('userInfo');
        if (userInfo) {
          token = JSON.parse(userInfo).token;
        }
      }

      if (!token) {
        throw new Error('Token de autenticação não encontrado');
      }

      const config = {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      };

      const response = await api.get('/api/tri-access/check', config);
      if (response.data.success) {
        setTriAccessStatus(response.data);
      }
    } catch (error) {
      console.error('Erro ao verificar status de acesso TRI:', error);
      // Em caso de erro, usar o status do objeto user como fallback
      setTriAccessStatus({
        hasAccess: user && (user.hasTriAccess === true && (!user.triAccessExpiry || new Date(user.triAccessExpiry) > new Date())),
        expiryDate: user?.triAccessExpiry
      });
    } finally {
      setCheckingAccess(false);
    }
  };

  // Initialize calculated averages and check TRI access status
  useEffect(() => {
    storeCalculatedAverages();
    checkTriAccessStatus(); // Verificar status TRI quando o componente for montado
  }, []);

  // Function to calculate averages
  const calculateAverages = () => {
    // Helper function to get numeric weight, defaulting to 1 if empty string
    const getWeightValue = (weight) => {
      if (weight === '' || weight === null || weight === undefined) {
        return 1; // Default weight
      }
      return weight;
    };

    // Calculate simple average
    const scores = [];
    if (correctAnswers.linguagens >= 1) scores.push(simulatedScores.linguagens);
    if (correctAnswers.humanas >= 1) scores.push(simulatedScores.humanas);
    if (correctAnswers.natureza >= 1) scores.push(simulatedScores.natureza);
    if (correctAnswers.matematica >= 1) scores.push(simulatedScores.matematica);

    // Always include redação score
    scores.push(simulatedScores.redacao);

    const total = scores.reduce((sum, score) => sum + score, 0);
    const simpleAverage = scores.length > 0 ? total / scores.length : 0;

    // Calculate weighted average
    let weightedSum = 0;
    let totalWeight = 0;

    if (correctAnswers.linguagens >= 1) {
      const weightValue = getWeightValue(weights.linguagens);
      weightedSum += simulatedScores.linguagens * weightValue;
      totalWeight += weightValue;
    }

    if (correctAnswers.humanas >= 1) {
      const weightValue = getWeightValue(weights.humanas);
      weightedSum += simulatedScores.humanas * weightValue;
      totalWeight += weightValue;
    }

    if (correctAnswers.natureza >= 1) {
      const weightValue = getWeightValue(weights.natureza);
      weightedSum += simulatedScores.natureza * weightValue;
      totalWeight += weightValue;
    }

    if (correctAnswers.matematica >= 1) {
      const weightValue = getWeightValue(weights.matematica);
      weightedSum += simulatedScores.matematica * weightValue;
      totalWeight += weightValue;
    }

    // Always include redação with its weight
    const redacaoWeightValue = getWeightValue(weights.redacao);
    weightedSum += simulatedScores.redacao * redacaoWeightValue;
    totalWeight += redacaoWeightValue;

    const weightedAverage = totalWeight > 0 ? weightedSum / totalWeight : 0;

    return {
      simpleAverage: Math.round(simpleAverage),
      weightedAverage: Math.round(weightedAverage)
    };
  };

  // Function to store calculated averages
  const storeCalculatedAverages = () => {
    const averages = calculateAverages();
    setCalculatedAverages(averages);
  };

  const handleShowResults = async () => {
    // Verificar status TRI em tempo real antes de mostrar resultados
    if (!hasAccessToEnemSimulator) {
      // Show upgrade message
      setShowUpgradeMessage(true);
      return;
    }

    // Calculate and store averages
    storeCalculatedAverages();

    // First hide the results if they're visible
    if (showResults) {
      setResultsVisible(false);
      setTimeout(() => {
        // Trigger animation sequence: fade out -> fade in
        setResultsAnimation(true);
        setTimeout(() => {
          setShowResults(true);
          setResultsVisible(true);
          setTimeout(() => {
            setResultsAnimation(false);
          }, 300); // Duration of fade-in
        }, 300); // Duration of fade-out
      }, 100); // Small delay before starting animation
    } else {
      // First time showing results
      setResultsAnimation(true);
      setTimeout(() => {
        setShowResults(true);
        setResultsVisible(true);
        setTimeout(() => {
          setResultsAnimation(false);
        }, 300); // Duration of fade-in
      }, 100); // Small delay before showing
    }
  };

  const handleRefazer = () => {
    // Recalculate averages when refazer is clicked
    storeCalculatedAverages();

    setResultsVisible(false);
    setTimeout(() => {
      setShowResults(false);
    }, 300); // Match the transition duration
  };

  const handleVoltar = async () => {
    setShowUpgradeMessage(false);
    // Verificar status TRI novamente ao voltar
    await checkTriAccessStatus();
  };

  return (
    <>
      <style>{`
        @keyframes fadeOutIn {
          0% { opacity: 1; }
          50% { opacity: 0; }
          100% { opacity: 1; }
        }
      `}</style>
      <div className="bg-white rounded-xl shadow-lg p-6 mb-6 text-gray-900 border border-gray-200">
      <div className="flex flex-col md:flex-row justify-between items-center">
        <div className="mb-4 md:mb-0">
          <h2 className="text-xl font-bold flex items-center text-purple-700">
            <svg className="w-6 h-6 mr-2 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            Simulador de Nota do ENEM
          </h2>
          <p className="text-sm text-gray-600 mt-1 flex items-center">
            Simule sua nota com base na quantidade de acertos nos simulados ou no exame.
            <span className="group relative ml-1 inline-block">
              <svg className="w-4 h-4 inline-block ml-1 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 hidden group-hover:block w-64 px-3 py-2 text-xs text-white bg-black bg-opacity-80 rounded-md z-10">
                Esta é uma simulação baseada na Teoria de Resposta ao Item (TRI). Os resultados reais podem variar.
              </span>
            </span>
          </p>
        </div>

        <div className="flex space-x-2">
          {checkingAccess ? (
            <button
              disabled
              className="bg-gray-300 text-gray-700 font-semibold px-4 py-2 rounded-lg shadow-md"
            >
              Verificando acesso...
            </button>
          ) : hasAccessToEnemSimulator ? (
            <button
              onClick={() => {
                simulateScores();
                handleShowResults();
              }}
              className="bg-purple-600 text-white font-semibold px-4 py-2 rounded-lg hover:bg-purple-700 transition-colors shadow-md"
            >
              Simular Nota
            </button>
          ) : (
            <button
              onClick={async () => {
                // Antes de redirecionar, verificar novamente o status
                await checkTriAccessStatus();
                // Se após verificar ainda não tem acesso, redirecionar
                if (!hasAccessToEnemSimulator) {
                  window.location.href = 'https://vestibula.com.br/venda-premium';
                }
              }}
              className="bg-yellow-500 text-white font-semibold px-4 py-2 rounded-lg hover:bg-yellow-600 transition-colors shadow-md"
            >
              Liberar Acesso
            </button>
          )}
          <button
            onClick={resetForm}
            className="bg-purple-100 text-purple-700 font-semibold px-4 py-2 rounded-lg hover:bg-purple-200 transition-colors shadow-md border border-purple-300"
          >
            Limpar
          </button>
        </div>
      </div>

      <div className="mt-6 grid grid-cols-1 md:grid-cols-5 gap-4">
        {/* Linguagens */}
        <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
          <label className="block text-sm font-medium mb-1 text-purple-700">Linguagens</label>
          <input
            type="number"
            min="1"
            max="45"
            value={correctAnswers.linguagens || ''}
            onChange={(e) => handleInputChange('linguagens', e.target.value)}
            className="w-full p-2 rounded text-gray-800 bg-white border border-gray-300 mb-2"
            placeholder="Acertos"
          />
          <label className="block text-xs font-medium mb-1 text-purple-600">Peso</label>
          <input
            type="number"
            min="0.1"
            max="10"
            step="0.1"
            value={weights.linguagens === '' ? '' : weights.linguagens}
            onChange={(e) => handleWeightChange('linguagens', e.target.value)}
            className="w-full p-1 rounded text-gray-800 bg-white border border-gray-300 text-sm"
            placeholder="Peso"
          />
          {correctAnswers.linguagens >= 1 && (
            <div className="mt-2 text-sm">
              <span className="font-semibold text-purple-700">Nota:</span> {hasAccessToEnemSimulator ? `${simulatedScores.linguagens} pts` :
                <span className="blur-sm hover:blur-none transition-all duration-300 cursor-help" title="Faça upgrade para ver o valor real">999 pts</span>}
            </div>
          )}
        </div>

        {/* Humanas */}
        <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
          <label className="block text-sm font-medium mb-1 text-purple-700">Humanas</label>
          <input
            type="number"
            min="1"
            max="45"
            value={correctAnswers.humanas || ''}
            onChange={(e) => handleInputChange('humanas', e.target.value)}
            className="w-full p-2 rounded text-gray-800 bg-white border border-gray-300 mb-2"
            placeholder="Acertos"
          />
          <label className="block text-xs font-medium mb-1 text-purple-600">Peso</label>
          <input
            type="number"
            min="0.1"
            max="10"
            step="0.1"
            value={weights.humanas === '' ? '' : weights.humanas}
            onChange={(e) => handleWeightChange('humanas', e.target.value)}
            className="w-full p-1 rounded text-gray-800 bg-white border border-gray-300 text-sm"
            placeholder="Peso"
          />
          {correctAnswers.humanas >= 1 && (
            <div className="mt-2 text-sm">
              <span className="font-semibold text-purple-700">Nota:</span> {hasAccessToEnemSimulator ? `${simulatedScores.humanas} pts` :
                <span className="blur-sm hover:blur-none transition-all duration-300 cursor-help" title="Faça upgrade para ver o valor real">999 pts</span>}
            </div>
          )}
        </div>

        {/* Natureza */}
        <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
          <label className="block text-sm font-medium mb-1 text-purple-700">Natureza</label>
          <input
            type="number"
            min="1"
            max="45"
            value={correctAnswers.natureza || ''}
            onChange={(e) => handleInputChange('natureza', e.target.value)}
            className="w-full p-2 rounded text-gray-800 bg-white border border-gray-300 mb-2"
            placeholder="Acertos"
          />
          <label className="block text-xs font-medium mb-1 text-purple-600">Peso</label>
          <input
            type="number"
            min="0.1"
            max="10"
            step="0.1"
            value={weights.natureza === '' ? '' : weights.natureza}
            onChange={(e) => handleWeightChange('natureza', e.target.value)}
            className="w-full p-1 rounded text-gray-800 bg-white border border-gray-300 text-sm"
            placeholder="Peso"
          />
          {correctAnswers.natureza >= 1 && (
            <div className="mt-2 text-sm">
              <span className="font-semibold text-purple-700">Nota:</span> {hasAccessToEnemSimulator ? `${simulatedScores.natureza} pts` :
                <span className="blur-sm hover:blur-none transition-all duration-300 cursor-help" title="Faça upgrade para ver o valor real">999 pts</span>}
            </div>
          )}
        </div>

        {/* Matemática */}
        <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
          <label className="block text-sm font-medium mb-1 text-purple-700">Matemática</label>
          <input
            type="number"
            min="1"
            max="45"
            value={correctAnswers.matematica || ''}
            onChange={(e) => handleInputChange('matematica', e.target.value)}
            className="w-full p-2 rounded text-gray-800 bg-white border border-gray-300 mb-2"
            placeholder="Acertos"
          />
          <label className="block text-xs font-medium mb-1 text-purple-600">Peso</label>
          <input
            type="number"
            min="0.1"
            max="10"
            step="0.1"
            value={weights.matematica === '' ? '' : weights.matematica}
            onChange={(e) => handleWeightChange('matematica', e.target.value)}
            className="w-full p-1 rounded text-gray-800 bg-white border border-gray-300 text-sm"
            placeholder="Peso"
          />
          {correctAnswers.matematica >= 1 && (
            <div className="mt-2 text-sm">
              <span className="font-semibold text-purple-700">Nota:</span> {hasAccessToEnemSimulator ? `${simulatedScores.matematica} pts` :
                <span className="blur-sm hover:blur-none transition-all duration-300 cursor-help" title="Faça upgrade para ver o valor real">999 pts</span>}
            </div>
          )}
        </div>

        {/* Redação */}
        <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
          <label className="block text-sm font-medium mb-1 text-purple-700">Redação</label>
          <input
            type="number"
            min="0"
            max="1000"
            defaultValue="800"
            onChange={(e) => {
              const value = Math.max(0, Math.min(1000, parseInt(e.target.value) || 0));
              setSimulatedScores(prev => ({
                ...prev,
                redacao: value
              }));
            }}
            className="w-full p-2 rounded text-gray-800 bg-white border border-gray-300 mb-2"
            placeholder="Pontuação"
          />
          <label className="block text-xs font-medium mb-1 text-purple-600">Peso</label>
          <input
            type="number"
            min="0.1"
            max="10"
            step="0.1"
            value={weights.redacao === '' ? '' : weights.redacao}
            onChange={(e) => handleWeightChange('redacao', e.target.value)}
            className="w-full p-1 rounded text-gray-800 bg-white border border-gray-300 text-sm"
            placeholder="Peso"
          />
          {simulatedScores.redacao > 0 && (
            <div className="mt-2 text-sm">
              <span className="font-semibold text-purple-700">Nota:</span> {hasAccessToEnemSimulator ? `${simulatedScores.redacao} pts` :
                <span className="blur-sm hover:blur-none transition-all duration-300 cursor-help" title="Faça upgrade para ver o valor real">999 pts</span>}
            </div>
          )}
        </div>
      </div>

      {/* Results Display - Only shown after clicking "Simular Nota" */}
      {showResults && hasAccessToEnemSimulator && (
        <div
          className="mt-6 pt-6 border-t border-gray-200"
          style={{
            opacity: resultsVisible ? 1 : 0,
            transition: 'opacity 0.3s ease-in-out',
            animation: resultsAnimation ? 'fadeOutIn 0.6s ease-in-out' : 'none'
          }}
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
            <div className="bg-gray-50 p-4 rounded-xl border border-gray-200">
              <h3 className="font-semibold text-lg mb-2 text-purple-700">Média Simples:</h3>
              <div className="text-3xl font-bold text-center bg-purple-50 py-4 rounded-lg border border-purple-200 text-purple-800">
                {calculatedAverages.simpleAverage} pts
              </div>
            </div>

            <div className="bg-gray-50 p-4 rounded-xl border border-gray-200">
              <h3 className="font-semibold text-lg mb-2 text-purple-700">Média Ponderada:</h3>
              <div className="text-3xl font-bold text-center bg-purple-50 py-4 rounded-lg border border-purple-200 text-purple-800">
                {calculatedAverages.weightedAverage} pts
              </div>
            </div>
          </div>

          <div className="text-center">
            <button
              onClick={handleRefazer}
              className="bg-purple-600 text-white font-semibold px-6 py-3 rounded-lg hover:bg-purple-700 transition-colors shadow-md"
            >
              Refazer
            </button>
          </div>
        </div>
      )}

      {/* Upgrade Message */}
      {showUpgradeMessage && (
        <div className="mt-6">
          <div className="text-center p-8 max-w-md bg-white rounded-xl shadow-lg mx-auto border border-gray-200">
            <h2 className="text-2xl font-bold text-purple-600 mb-4">É necessário atualizar o seu plano para ter acesso</h2>
            <div className="mb-4">
              <button
                onClick={async () => {
                  // Verificar status TRI novamente antes de redirecionar
                  await checkTriAccessStatus();
                  // Se após verificar ainda não tem acesso, redirecionar
                  if (!hasAccessToEnemSimulator) {
                    window.location.href = 'https://vestibula.com.br/venda-premium';
                  }
                }}
                className="bg-yellow-600 hover:bg-yellow-700 text-white font-bold py-3 px-6 rounded-full transition-colors duration-300 shadow-lg"
              >
                Atualize seu Plano
              </button>
            </div>
            <button
              onClick={handleVoltar}
              className="text-gray-600 hover:text-gray-800 font-medium text-sm underline"
            >
              Voltar
            </button>
          </div>
        </div>
      )}
    </div>
    </>
  );
};

export default EnemTriSimulatorBar;